/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, {
  useState, useEffect, useRef, useCallback,
} from 'react';
import IcomoonReact from 'icomoon-react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import { useDispatch, useSelector } from 'react-redux';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import StaticAddColumnDropdownComponent from './StaticAddColumnDropdownComponent';
import TBportalTooltip from '../../../../shared/components/TBportalTooltip';
import Text from '../../../../shared/components/Text/Text';
import {
  updateProgrammedCalendarItem,
  updateSavedWorkoutItem,
  updateReduxCalendarItem,
  updateReduxProgramItem,
  swapProgrammedItemOnChildCalendar,
  setCombineWithInfo,
} from '../../ducks/calendarActions';
import SwapPropDropdownCircuit from './SwapPropDropdownCircuit';
import capitalizeWords from '../../../../shared/utils/capitalizeWords';
import useSessionState from './hooks/useSessionState';
import { getDebouncedHandlerForTable, flushDebounceForTable } from './hooks/debounceHandler';
import { useFlushDebounceOnMouseMove } from './hooks/useFlushDebounceOnMouseMove';

const RANGE_FIELDS = new Set(['time', 'rest per rep']);

const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const WrapperRow = styled('div')`
  display: flex;
  width: 100%;
`;

const StaticDropdownWrapper = styled('div')`
  display: flex;
  margin-left: 16px;
  align-items: self-start;
  margin-top: 17px;
  flex-direction: column;
`;

const RemoveWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-bottom: 12px;
  margin-top: 12px;
  gap: 22px;
`;

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: scroll;
`;

const PrimaryRow = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const ValueRow = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

const PrimaryRowValue = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  margin-bottom: 3px;
`;

const RowValue = styled('input')`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  height: 32px;
  background: ${(props) => props.background};
  border: 1px solid #EEEEEE;
  text-align: center;
  border-radius: 4px;
  color: ${(props) => (props.textColor ? props.textColor : '#444444')};

  ::placeholder {
    color: ${(props) => (props.textColor ? props.textColor : '#444444')};
  }
`;

const SetRowValue = styled('input')`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Nunito Sans';
  width: 100%;
  height: 32px;
  background: #FCFCFC;
  border: 1px solid #EEEEEE;
  text-align: center;
  color: #BDBDBD;
  border-radius: 4px;
`;

const AddSetButtonContainer = styled('div')`
  display: flex;
  align-items: center;
`;

const AddColumnButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const RemoveButtonContainer = styled('div')`
  display: flex;
  min-height: 34px;
`;

const AddSetIcon = styled('div')`
  padding: 4px;
  background: #444444;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const AddColumnIcon = styled('div')`
  padding: 4px;
  background: #444444;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RemoveIcon = styled('div')`
  padding: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
  cursor: pointer;
`;

const RowsContainer = styled('div')`
  height: 55px;
  display: flex;
  width: 100%;
  gap: 16px;
  align-items: center;
`;

const RowValueContainer = styled('div')`
  width: 100%;
  min-width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SetRowValueContainer = styled('div')`
  display: flex;
  justify-content: center;
  min-width: 70px;
  max-width: 70px;
`;

const AddSetText = styled('div')`
  font-weight: 400;
  font-size: 16px;
  font-family: 'Nunito Sans';
  margin-left: 5px;
`;

const NameAndDropdown = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3px;
`;

const PrimaryValueContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  width: 100%;
  min-width: 180px;
`;

const SetPrimaryValueContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
  min-width: 70px;
  max-width: 70px;
`;

const TooltipDataContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 16px;
  padding-left: 16px;
  gap: 10px;
  border-radius: 4px;
  max-width: 250px;
`;

const ExerciseTableCircuit = ({
  content,
  index,
  coachCompletion,
  completionOnly,
  swapDropdownSelectedExercise,
  nonSwappedItemFromParentCalendar,
  isRecurring = '',
  measure,
  date,
  dayNumber,
}) => {
  const targetRef = useRef(null);
  const targetRefRest = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltipRest, setShowTooltipRest] = useState(false);

  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const calendarContainerScrollPositionTop = useSelector((state) => state.calendar.data.calendarContainerScrollPositionTop);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const effectiveDate = date || selectedDate;
  const endpointFormattedDate = moment(effectiveDate).format('YYYY-MM-DD');
  const combineWithInfo = useSelector((state) => state.calendar.data.combineWithInfo);
  const focusTarget = useSelector((state) => state.calendar.data.focusTarget);

  const [primaryRows, setPrimaryRows] = useState([
    { name: 'rounds' },
    { name: 'rest', label: 'Rest (s)' },
    /** { name: 'time limit' }, */
    /** need to bring in initial values off of conent.exercise to determine if reps or sets are shown in primary row */
    { name: ((content?.exercise?.inputType === 'T' || content?.exercise?.inputType === 'C') && content?.exercise?.detailType === 'sets') || content?.exercise?.inputType === 'S' ? 'sets' : 'reps' },
  ]);

  /** we need to use session storage for primary row switch values so that if the user adds a field
   * it will not get wiped out between debounces if they haven't entered a value yet, changes to individual table properties
   *  will persist the session
   */
  const [primaryRowSwitch, setPrimaryRowSwitchState] = useSessionState(
    'primaryRowSwitchCircuitTable',
    content?.assignedId,
    {
      rounds: true,
      rest: true,
      'time limit': false,
      /** need to bring in initial value off of conent.exercise */
      reps: ((content?.exercise?.inputType === 'T' || content?.exercise?.inputType === 'C') && content?.exercise?.detailType === 'reps') || content?.exercise?.inputType === 'R',
      /** need to bring in initial value off of conent.exercise */
      sets: ((content?.exercise?.inputType === 'T' || content?.exercise?.inputType === 'C') && content?.exercise?.detailType === 'sets') || content?.exercise?.inputType === 'S',
    },
  );

  const [rest, setRest] = useState(null);

  const [firstPrimaryRowSwitchLoad, setFirstPrimaryRowSwitchLoad] = useState(true);
  const [firstContentLoad, setFirstContentLoad] = useState(true);
  const [firstLoadDropdownOptions, setFirstLoadDropdownOptions] = useState(true);

  const keySwapDictionary = {
    time: 'prescribedValue',
    rounds: 'rounds',
    reps: 'reps',
    'rest per rep': 'restPerRep',
  };

  const [rows, setRows] = useState(content?.sets || []);

  // Ref for the table container, used to scope keyboard shortcuts
  const tableContainerRef = useRef(null);

  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true; /** skip first run because cell measurer wrapper will get that and we don't want to run it twice */
      return;
    }

    if (measure) {
      measure();
    }
  }, [rows]);

  const typeFormatter = (typeDescription) => {
    if (typeDescription === 'lift') {
      return 'lift';
    }
    if (typeDescription === 'cardio') {
      return 'saq+c';
    }
    if (typeDescription === 'circuit') {
      return 'circuit';
    }
    return '';
  };

  const dispatch = useDispatch();

  const formatDate = () => `${moment(effectiveDate).format('YYYY-MM-DD')}`;

  /** debounced function will maintain values at the time of creation
     * on mount unless passed updated values, we can't to make sure we are
     * always using the most updated selected date and current user
     */
  const currentUserRef = useRef(currentUser);
  const selectedDateRef = useRef(effectiveDate);
  const dayNumberRef = useRef(dayNumber);

  useEffect(() => {
    currentUserRef.current = currentUser;
    selectedDateRef.current = effectiveDate;
    dayNumberRef.current = dayNumber;
  }, [currentUser, effectiveDate, dayNumber]);

  useFlushDebounceOnMouseMove(content.assignedId, nonSwappedItemFromParentCalendar);

  const debouncedHandleUpdateCircuitItem = getDebouncedHandlerForTable(content.assignedId, (
    updatedRows,
    dbrest,
    dbCoachCompletion,
    dbCompletionOnly,
    dbContent,
    dbIndex,
    dbNonSwappedItemFromParentCalendar,
    reorder = false,
  ) => {
    const prunedArray = updatedRows.map(({ prescribedType, percent, ...remainder }) => remainder);
    const updateItem = {
      assignedId: dbContent.assignedId,
      exerciseId: dbContent.exerciseId,
      order: dbIndex,
      sets: prunedArray,
      groupingLetter: dbContent.groupingLetter,
      additionalInfo: dbContent.additionalInfo || null,
      coachCompletion: dbCoachCompletion,
      completionOnly: dbCompletionOnly,
      description: dbContent?.exercise?.description || null,
      type: typeFormatter(dbContent?.exercise?.typeDescription),
    };
    if (dbrest) {
      updateItem.restTime = dbrest;
    }
    if (programType === 'calendar') {
      if (!isRecurring) {
        updateItem.date = moment(effectiveDate).format('YYYY-MM-DD');
      } else {
        updateItem.isRecurring = isRecurring;
      }
    }
    if (programType === 'free-form-program') {
      updateItem.dayNumber = dayNumberRef.current;
    }
    if (programType === 'free-form-program') {
      dispatch(updateSavedWorkoutItem(currentUserRef.current.accountCode, updateItem, dbIndex, dayNumberRef.current, reorder));
    }
    if (programType === 'calendar') {
      if (dbNonSwappedItemFromParentCalendar) {
        dispatch(swapProgrammedItemOnChildCalendar(currentUserRef.current.accountCode, updateItem, dbIndex, formatDate(selectedDateRef.current), reorder));
      } else {
        dispatch(updateProgrammedCalendarItem(currentUserRef.current.accountCode, updateItem, dbIndex, formatDate(selectedDateRef.current), reorder));
      }
    }
  }, 4000);

  /** This useEffect listens for changes is the exercise chosen from the
   * table dropdown menu that can be used to change the exericse
   * it immediately update the item in redux so we see the change in the table
   * immediately, then we call the debouce update the same way we do
   * for every other input change
   */
  useEffect(() => {
    if (swapDropdownSelectedExercise) {
      const prunedArray = rows.map(({ prescribedType, percent, ...remainder }) => remainder);
      const updatedItem = {
        ...content,
        additionalInfo: swapDropdownSelectedExercise?.additionalInfo,
        description: swapDropdownSelectedExercise?.description,
        assignedId: content.assignedId,
        date: programType === 'free-form-program' ? '' : formatDate(effectiveDate),
        exerciseId: swapDropdownSelectedExercise.exerciseId,
        exercise: swapDropdownSelectedExercise,
        title: swapDropdownSelectedExercise?.name,
        order: index,
        sets: prunedArray,
        coachCompletion,
        completionOnly,
        type: typeFormatter(swapDropdownSelectedExercise.typeDescription),
      };
      if (rest) {
        updatedItem.restTime = rest;
      }
      if (programType === 'free-form-program') {
        dispatch(updateReduxProgramItem(updatedItem, dayNumber || selectedProgramDayNumber, index));
      } else {
        dispatch(updateReduxCalendarItem(updatedItem, endpointFormattedDate, index));
      }
      debouncedHandleUpdateCircuitItem.cancel();
      debouncedHandleUpdateCircuitItem(rows, rest, coachCompletion, completionOnly, updatedItem, index, nonSwappedItemFromParentCalendar);
      flushDebounceForTable(content.assignedId);
    }
  }, [swapDropdownSelectedExercise]);

  useEffect(() => {
    const isSource = combineWithInfo?.source?.length
      ? combineWithInfo.source.some((item) => item?.assignedId.toString() === content?.assignedId.toString())
      : false;

    const sourceItem = combineWithInfo?.source?.find(
      (item) => item?.assignedId.toString() === content?.assignedId.toString(),
    );

    const isTarget = combineWithInfo?.target?.assignedId === content?.assignedId;

    const targetItem = combineWithInfo?.target;

    if (combineWithInfo && ((isSource) || (isTarget))) {
      dispatch(setCombineWithInfo(null));
      const prunedArray = rows.map(({ prescribedType, percent, ...remainder }) => remainder);
      const updatedItem = {
        ...content,
        date: programType === 'free-form-program' ? '' : formatDate(effectiveDate),
        order: index,
        sets: prunedArray,
        groupingLetter: isSource
          ? sourceItem?.groupingLetter
          : isTarget
            ? targetItem?.groupingLetter
            : content?.groupingLetter,

        groupingColorCode: isSource
          ? sourceItem?.groupingColorCode
          : isTarget
            ? targetItem?.groupingColorCode
            : content?.groupingColorCode,
        coachCompletion,
        completionOnly,
      };
      if (rest) {
        updatedItem.restTime = rest;
      }
      const reorder = true;
      debouncedHandleUpdateCircuitItem(
        rows,
        rest,
        coachCompletion,
        completionOnly,
        updatedItem,
        index,
        nonSwappedItemFromParentCalendar,
        reorder,
      );
      flushDebounceForTable(content.assignedId);
    }
  }, [combineWithInfo]);

  // This useEffect is responsible for managing focus on input fields when the focusTarget changes.
  // It checks if the current focusTarget's assignedId matches the content's assignedId.
  // If they match, it finds the first input element with a data-focus-target attribute equal to the content's assignedId.
  // Once found, it sets a timeout to focus on this input element after a short delay, ensuring the DOM is ready.
  useEffect(() => {
    if (focusTarget?.assignedId === content.assignedId) {
      const firstInput = document.querySelector(`[data-focus-target="${content.assignedId}"]`);
      if (firstInput) {
        setTimeout(() => {
          firstInput.focus();
        }, 100); // Small delay to ensure DOM is ready
      }
    }
  }, [focusTarget, content.assignedId]);

  /** NEED TO PASS CONTENT INTO EACH DEBOUNCE FUNCTION CALL
  /** ADDED CODE TO TEST SWAP ABOVE */
  /** needed to setPrimaryRow and setPrimaryRowSwitch state when content changes, put in useEffect below */

  useEffect(() => {
    if (!firstLoadDropdownOptions) {
      debouncedHandleUpdateCircuitItem(rows, rest, coachCompletion, completionOnly, content, index, nonSwappedItemFromParentCalendar);
      if (nonSwappedItemFromParentCalendar) {
        flushDebounceForTable(content.assignedId);
      }
    } else {
      setFirstLoadDropdownOptions(false);
    }
  }, [coachCompletion, completionOnly]);

  const setRestAndUpdate = (value) => {
    const intRest = parseInt(value, 10);
    // Prevent negative values
    if (intRest < 0) return;
    setRest(intRest);
    debouncedHandleUpdateCircuitItem(rows, intRest, coachCompletion, completionOnly, content, index, nonSwappedItemFromParentCalendar);
  };

  // Track if all optional columns are enabled to hide the add column button
  const [showAddColumnButton, setShowAddColumnButton] = useState(true);

  // Hide add column button when all optional properties are enabled
  useEffect(() => {
    // For circuit tables, rest is the main optional property
    // reps/sets are always shown (one or the other based on exercise type)
    const allOptionalPropertiesEnabled = primaryRowSwitch.rest
      && (primaryRowSwitch.reps || primaryRowSwitch.sets);

    setShowAddColumnButton(!allOptionalPropertiesEnabled);
  }, [
    primaryRowSwitch.rest,
    primaryRowSwitch.reps,
    primaryRowSwitch.sets,
  ]);

  // this is the function that updates the non-set-based values when columns are added
  const setPrimaryRowSwitch = (newState) => {
    setPrimaryRowSwitchState((prevState) => {
      const updatedState = { ...prevState, ...newState };

      if (!firstPrimaryRowSwitchLoad) {
        setFirstPrimaryRowSwitchLoad(false);

        // Check if any columns are being removed (turned from true to false)
        const columnsBeingRemoved = Object.keys(newState).some((key) => prevState[key] === true && newState[key] === false);

        const initializedRows = [...rows];
        const updatedRows = initializedRows.map((row) => {
          const cleanedRow = { ...row };
          Object.keys(newState).forEach((key) => {
            if (!newState[key]) {
              delete cleanedRow[keySwapDictionary[key]];
            }
          });
          return cleanedRow;
        });
        setRows(updatedRows);

        let newRestValue;
        if (!newState.rest) {
          setRest(null);
          newRestValue = null;
        } else {
          newRestValue = rest;
        }

        // Always call API when columns are being removed, otherwise check for empty fields
        if (columnsBeingRemoved) {
          // If columns are being removed, always trigger the API call
          debouncedHandleUpdateCircuitItem(
            updatedRows,
            newRestValue,
            coachCompletion,
            completionOnly,
            content,
            index,
            nonSwappedItemFromParentCalendar,
          );
        } else {
          // For adding columns, check if any fields are empty before making API call
          const fieldsToCheck = Object.keys(newState).filter((key) => newState[key] && keySwapDictionary[key]);
          const hasEmptyFields = fieldsToCheck.some((key) => {
            const fieldKey = keySwapDictionary[key];
            return updatedRows.some((row) => {
              const fieldValue = row[fieldKey];
              return !fieldValue || fieldValue === null || fieldValue === '';
            });
          });

          // Only call the API if no fields are empty or if no trackable fields are active
          if (!hasEmptyFields || fieldsToCheck.length === 0) {
            debouncedHandleUpdateCircuitItem(
              updatedRows,
              newRestValue,
              coachCompletion,
              completionOnly,
              content,
              index,
              nonSwappedItemFromParentCalendar,
            );
          }
        }
      }

      return updatedState;
    });
    setFirstPrimaryRowSwitchLoad(false);
  };

  // this is the function that sets the appropriate columns and values on load
  useEffect(() => {
    if (content && content.sets) {
      setRows(content.sets);
      if (firstContentLoad) {
        const newPrimaryRowSwitch = { ...primaryRowSwitch };
        content?.sets.forEach((set) => {
          if (set.prescribedValue) {
            newPrimaryRowSwitch.time = true;
          }
          if (set.restPerRep) {
            newPrimaryRowSwitch['rest per rep'] = true;
          }
          if (set.reps) {
            newPrimaryRowSwitch.reps = true;
          }
        });
        if (content) {
          if (content.restTime) {
            newPrimaryRowSwitch.rest = true;
            setRest(content.restTime);
          }
        }
        setPrimaryRowSwitch(newPrimaryRowSwitch);
        setFirstContentLoad(false);
      }
    }

    /** ADDED FOR SWAPPING EXERCISE NAME NEED - TO UPDATE SETS AND REPS WHEN CONTNENT CHANGES */
    setPrimaryRows([
      { name: 'rounds' },
      { name: 'rest', label: 'Rest (s)' },
      /** { name: 'time limit' }, */
      /** need to bring in initial values off of conent.exercise to determine if reps or sets are shown in primary row */
      { name: ((content?.exercise?.inputType === 'T' || content?.exercise?.inputType === 'C') && content?.exercise?.detailType === 'sets') || content?.exercise?.inputType === 'S' ? 'sets' : 'reps' },
    ]);
    /** ADDED FOR SWAPPING EXERCISE NAME - NEED TO UPDATE SETS AND REPS WHEN CONTNENT CHANGES */
    setPrimaryRowSwitchState({
      rounds: true,
      rest: !!content.restTime,
      'time limit': false,
      /** need to bring in initial value off of conent.exercise */
      reps: ((content?.exercise?.inputType === 'T' || content?.exercise?.inputType === 'C') && content?.exercise?.detailType === 'reps') || content?.exercise?.inputType === 'R',
      /** need to bring in initial value off of conent.exercise */
      sets: ((content?.exercise?.inputType === 'T' || content?.exercise?.inputType === 'C') && content?.exercise?.detailType === 'sets') || content?.exercise?.inputType === 'S',
    });
  }, [content]);

  const updateColumnName = useCallback((oldName, newName) => {
    setPrimaryRows(
      (prevRows2) => prevRows2.map(
        (row) => (row.name === oldName ? { ...row, name: newName } : row),
      ),
    );

    setPrimaryRowSwitch((prevSwitch) => ({
      ...prevSwitch,
      [oldName]: false,
      [newName]: true,
    }));
  }, []);

  const addRow = () => {
    const lastRow = rows[rows.length - 1];
    const copyLastRow = { ...lastRow, setNumber: rows.length + 1 };
    const updatedRows = [...rows, copyLastRow];
    setRows(updatedRows);
    debouncedHandleUpdateCircuitItem(updatedRows, rest, coachCompletion, completionOnly, content, index, nonSwappedItemFromParentCalendar);
  };

  const removeRow = (removeIndex) => {
    const updatedRows = rows
      .filter((_, i) => i !== removeIndex) /** Remove the row at removeIndex */
      .map((row, mapIndex) => ({
        ...row,
        setNumber: mapIndex + 1, /** Update setNumber to maintain sequential order */
      }));

    setRows(updatedRows);
    debouncedHandleUpdateCircuitItem(updatedRows, rest, coachCompletion, completionOnly, content, index, nonSwappedItemFromParentCalendar);
  };

  const handleInputChange = (index2, field, value) => {
    let parsedValue;
    if (RANGE_FIELDS.has(field)) {
      // Send pure numbers as floats, ranges/+ as strings
      if (value && /^\d+(\.\d+)?$/.test(value)) {
        parsedValue = parseFloat(value);
      } else {
        parsedValue = value; // range/+ token or empty
      }
      // Prevent negative numbers
      if (typeof parsedValue === 'number' && parsedValue < 0) return;
    } else {
      parsedValue = value;
    }

    setRows((prevRows2) => {
      const fieldKey = keySwapDictionary[field];

      // Check if this is the first set and we should auto-fill
      const shouldAutoFill = index2 === 0 && parsedValue && parsedValue !== null && parsedValue !== '';

      let updatedRows;
      if (shouldAutoFill) {
        // Get the current value in the first set
        const currentFirstSetValue = prevRows2[0][fieldKey];

        // Check if all other sets for this field are empty OR have the same value as the current first set
        const otherSetsAreEmptyOrMatchCurrent = prevRows2.slice(1).every((row) => {
          const fieldValue = row[fieldKey];
          return !fieldValue || fieldValue === null || fieldValue === '' || fieldValue === currentFirstSetValue;
        });

        if (otherSetsAreEmptyOrMatchCurrent) {
          // Auto-fill all sets with the same value
          updatedRows = prevRows2.map((row) => ({
            ...row,
            [fieldKey]: parsedValue,
          }));
        } else {
          // Only update the current row
          updatedRows = prevRows2.map((row, i) => (
            i === index2 ? { ...row, [fieldKey]: parsedValue } : row
          ));
        }
      } else {
        // Normal update - only change the current row
        updatedRows = prevRows2.map((row, i) => (
          i === index2 ? { ...row, [fieldKey]: parsedValue } : row
        ));
      }

      // Check if any field has empty values before making API call
      const hasEmptyFields = updatedRows.some((row) => {
        const fieldValue = row[fieldKey];
        return !fieldValue || fieldValue === null || fieldValue === '';
      });

      // Only call the API if no fields are empty
      if (!hasEmptyFields) {
        debouncedHandleUpdateCircuitItem(
          updatedRows,
          rest,
          coachCompletion,
          completionOnly,
          content,
          index,
          nonSwappedItemFromParentCalendar,
        );
      }

      return updatedRows;
    });
  };

  // Helper function to validate key input for numbers-only fields
  // Pass allowRangeNotation=true for time (prescribed value) and rest per rep fields
  const isValidNumberKey = (key, currentValue, allowRangeNotation = false) => {
    // Allow navigation and editing keys
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(key)) {
      return true;
    }

    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z
    if (key === 'a' || key === 'c' || key === 'v' || key === 'x' || key === 'z') {
      return true; // These will be handled by the browser with Ctrl modifier
    }

    // Allow decimal point; for range fields allow one per segment (split by '-')
    if (key === '.') {
      if (allowRangeNotation) {
        const currentSegment = currentValue.split('-').pop();
        if (!currentSegment.includes('.')) return true;
      } else if (!currentValue.includes('.')) {
        return true;
      }
    }

    // Allow digits
    if (/^\d$/.test(key)) {
      return true;
    }

    // Allow dash (range) and plus notation for range fields
    if (allowRangeNotation && (key === '-' || key === '+')) {
      return true;
    }

    return false;
  };

  const columnInputResolver = (name, rowIndex, row) => {
    if (name === 'rest') {
      return (
        <RowValueContainer>
          <RowValue
            type='number'
            value={rest}
            onChange={(e) => setRestAndUpdate(e.target.value)}
            onKeyDown={(e) => {
              // Prevent commas and validate for numbers-only field
              if (e.key === ',' || (!e.ctrlKey && !isValidNumberKey(e.key, e.target.value))) {
                e.preventDefault();
              }
            }}
            background='#FCFCFC'
          />
        </RowValueContainer>
      );
    }
    if (name === 'completed time') {
      return (
        <RowValueContainer>
          <RowValue
            value={(content?.exercise?.inputType === 'T' || content?.exercise?.inputType === 'C') ? '' : content?.exercise?.detail}
            placeholder='-'
            /** disable the ability to edit this field */
            disabled
            background='#FCFCFC'
            textColor='#BDBDBD'
          />
        </RowValueContainer>
      );
    }
    if (name === 'reps' || name === 'sets') {
      return (
        <RowValueContainer>
          <RowValue
          /** pull in intial values of content.exercise
           * this field will be disabled so doesn not need onChange
           */
            value={((name === 'reps' && content?.exercise?.inputType === 'R') || (name === 'sets' && content?.exercise?.inputType === 'S')) ? '' : content?.exercise?.detail}
          /** disable ablity to edit these fields */
            disabled
            placeholder='-'
            type='text'
            background='#FCFCFC'
            textColor='#BDBDBD'
          />
        </RowValueContainer>
      );
    }
    const isRangeField = RANGE_FIELDS.has(name);
    return (
      <RowValueContainer>
        <RowValue
          type={isRangeField ? 'text' : 'number'}
          aria-label={`${name} for set ${rowIndex + 1}`}
          value={row[keySwapDictionary[name]]}
          onChange={(e) => handleInputChange(rowIndex, name, e.target.value)}
          onKeyDown={(e) => {
            // Always prevent commas
            if (e.key === ',') {
              e.preventDefault();
              return;
            }

            // Skip validation for disabled fields
            if (name === 'velocity') {
              return;
            }

            // Validate for numbers-only fields
            if (!e.ctrlKey && !isValidNumberKey(e.key, e.target.value, isRangeField)) {
              e.preventDefault();
            }
          }}
          disabled={name === 'velocity'}
          background={name === 'velocity' ? '#BDBDBD' : '#FCFCFC'}
          data-focus-target={
            // Add focus target to the first editable field that's visible and in the first row
            rowIndex === 0 && (
              (name === 'time' && primaryRowSwitch.time)
            )
              ? content.assignedId
              : undefined
          }
        />
      </RowValueContainer>
    );
  };

  return (
    <Wrapper
      ref={tableContainerRef}
      onBlur={nonSwappedItemFromParentCalendar
        ? () => flushDebounceForTable(content.assignedId)
        : undefined}
    >
      <WrapperRow>
        <Container>
          <PrimaryRow>
            {primaryRows.map((primaryRow) => (
              primaryRowSwitch[primaryRow.name] ? (
                primaryRow.name === 'rounds' ? <SetPrimaryValueContainer>{capitalizeWords(primaryRow.name)}</SetPrimaryValueContainer> : (
                  <PrimaryValueContainer>
                    <PrimaryRowValue>
                      {(primaryRow.name === 'reps' && content?.exercise?.inputType === 'R') || (primaryRow.name === 'sets' && content?.exercise?.inputType === 'S') || (primaryRow.name === 'completed time' && content?.exercise.inputType === 'T') ? (
                        <NameAndDropdown
                          ref={targetRef}
                        >
                          {((primaryRow.name === 'reps') || (primaryRow.name === 'sets') || (primaryRow.name === 'completed time')) && (
                          <IcomoonReact
                            iconSet={iconSet}
                            size={14}
                            icon='info2'
                            color='rgba(189, 189, 189, 1)'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                          />
                          )}
                          {showTooltip && (
                          <TBportalTooltip setShowToolTip={setShowTooltip} targetRef={targetRef} backgroundColor='rgba(68, 68, 68, 1)' scrollContainerRefTopPosition={calendarContainerScrollPositionTop}>
                            <TooltipDataContainer>
                              <Text fontSize='13px' fontWeight={400} color='white'>Athlete input only</Text>
                            </TooltipDataContainer>
                          </TBportalTooltip>
                          )}
                          <SwapPropDropdownCircuit
                            visible={false}
                            setPrimaryRowSwitch={setPrimaryRowSwitch}
                            primaryRowSwitch={primaryRowSwitch}
                            rowName={primaryRow.name}
                            size={12}
                            updateColumnName={updateColumnName}
                            name={capitalizeWords(primaryRow.name)}
                          />
                        </NameAndDropdown>
                      ) : (
                        <NameAndDropdown
                          ref={
                          primaryRow.name === 'rest'
                            ? targetRefRest : null
                        }
                        >
                          {(primaryRow.name === 'rest') && (
                          <IcomoonReact
                            iconSet={iconSet}
                            size={14}
                            icon='info2'
                            color='rgba(189, 189, 189, 1)'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => {
                              if (primaryRow.name === 'rest') {
                                setShowTooltipRest(true);
                              }
                            }}
                            onMouseLeave={() => {
                              if (primaryRow.name === 'rest') {
                                setShowTooltipRest(false);
                              }
                            }}
                          />
                          )}
                          {primaryRow.name === 'rest' && showTooltipRest && (
                          <TBportalTooltip targetRef={targetRefRest} backgroundColor='rgba(68, 68, 68, 1)' setShowToolTip={setShowTooltipRest} scrollContainerRefTopPosition={calendarContainerScrollPositionTop}>
                            <TooltipDataContainer>
                              <Text fontSize='13px' fontWeight={400} color='white'>Rest value will be the same for all sets.</Text>
                            </TooltipDataContainer>
                          </TBportalTooltip>
                          )}
                          <SwapPropDropdownCircuit
                           /** coach SHOULD always be able to edit and swap rest and rounds */
                            visible={primaryRow.name === 'rounds' || primaryRow.name === 'rest'}
                            setPrimaryRowSwitch={setPrimaryRowSwitch}
                            primaryRowSwitch={primaryRowSwitch}
                            rowName={primaryRow.name}
                            size={12}
                            updateColumnName={updateColumnName}
                            name={capitalizeWords(primaryRow.name)}
                          />
                        </NameAndDropdown>
                      )}
                    </PrimaryRowValue>
                  </PrimaryValueContainer>
                )
              ) : null
            ))}
          </PrimaryRow>
          {rows.map((row, rowIndex) => (
            <ValueRow key={rowIndex}>
              <RowsContainer>
                {primaryRows.map((primaryRow) => (
                  primaryRowSwitch[primaryRow.name] ? (
                    primaryRow.name === 'rounds' ? (
                      <SetRowValueContainer>
                        <SetRowValue
                          type='number'
                          aria-label={`${primaryRow.name} for set ${rowIndex + 1}`}
                          value={rowIndex + 1}
                          disabled
                          onChange={(e) => handleInputChange(rowIndex, primaryRow.name, e.target.value)}
                        />
                      </SetRowValueContainer>
                    )
                      : columnInputResolver(primaryRow.name, rowIndex, row)
                  ) : null
                ))}
              </RowsContainer>
            </ValueRow>
          ))}
        </Container>
        <StaticDropdownWrapper>
          {showAddColumnButton && (
          <StaticAddColumnDropdownComponent
            primaryRows={primaryRows}
            setPrimaryRows={setPrimaryRows}
            primaryRowSwitch={primaryRowSwitch}
            setPrimaryRowSwitch={setPrimaryRowSwitch}
            setPrimaryRowSwitchState={setPrimaryRowSwitchState}
            size={12}
            containerRef={tableContainerRef}
            assignedId={content.assignedId}
          >
            <AddColumnButtonContainer className='add-column-button'>
              <AddColumnIcon>
                <IcomoonReact
                  iconSet={iconSet}
                  size={12}
                  icon='plus'
                  color='white'
                />
              </AddColumnIcon>
            </AddColumnButtonContainer>
          </StaticAddColumnDropdownComponent>
          )}
          <RemoveWrapper>
            {rows.map((row, rowIndex) => (
              rows.length !== 1 ? (
                <RemoveButtonContainer key={row.setNumber || rowIndex} onClick={() => removeRow(rowIndex)} tabIndex={-1}>
                  <RemoveIcon>
                    <IcomoonReact
                      iconSet={iconSet}
                      size={12}
                      icon='remove'
                      color='#9E9E9E'
                    />
                  </RemoveIcon>
                </RemoveButtonContainer>
              ) : <div key={row.setNumber || rowIndex} style={{ display: 'flex', minWidth: 20, minHeight: 34 }} />
            ))}
          </RemoveWrapper>
        </StaticDropdownWrapper>
      </WrapperRow>
      <AddSetButtonContainer
        onClick={addRow}
        onKeyDown={(e) => {
          if (e.key === 'Tab' && !e.shiftKey) {
            // Check if this is the last exercise in the list
            const allExerciseElements = document.querySelectorAll('[class*="AddSetButtonContainer"]');
            const currentIndex = Array.from(allExerciseElements).indexOf(e.target);
            const isLastExercise = currentIndex === allExerciseElements.length - 1;

            if (isLastExercise) {
              e.preventDefault();
              // Find and focus the ExercisePicker button
              const exercisePickerButton = document.querySelector('[class*="AddExerciseButtonContainer"]:last-child');
              if (exercisePickerButton) {
                exercisePickerButton.focus();
              }
            }
          }
        }}
      >
        <AddSetIcon>
          <IcomoonReact
            iconSet={iconSet}
            size={12}
            icon='plus'
            color='white'
          />
        </AddSetIcon>
        <AddSetText>
          Add Set
        </AddSetText>
      </AddSetButtonContainer>
    </Wrapper>
  );
};

ExerciseTableCircuit.defaultProps = {
  isRecurring: '',
  date: null,
  dayNumber: null,
};

ExerciseTableCircuit.propTypes = {
  content: PropTypes.instanceOf(Object).isRequired,
  swapDropdownSelectedExercise: PropTypes.instanceOf(Object).isRequired,
  index: PropTypes.number.isRequired,
  coachCompletion: PropTypes.bool.isRequired,
  completionOnly: PropTypes.bool.isRequired,
  nonSwappedItemFromParentCalendar: PropTypes.bool.isRequired,
  isRecurring: PropTypes.string,
  measure: PropTypes.func.isRequired,
  date: PropTypes.string,
  dayNumber: PropTypes.number,
};

export default ExerciseTableCircuit;
